import React, { Component } from "react";
import { TouchableOpacity, Animated } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { styles } from "./styles";

export class ScrollIndicator extends Component {
  constructor(props) {
    super(props);
    this.opacity = new Animated.Value(props.visible ? 1 : 0);
  }

  componentDidUpdate = () => {
    Animated.timing(this.opacity, {
      toValue: this.props.visible ? 1 : 0,
      duration: 100,
      useNativeDriver: true,
    }).start();
  };

  render() {
    const { onPress, icon } = this.props;
    const containerStyle = { opacity: this.opacity };

    return (
      <Animated.View style={containerStyle}>
        <TouchableOpacity onPress={onPress} style={styles.icon}>
          <Icon name={icon} color="white" />
        </TouchableOpacity>
      </Animated.View>
    );
  }
}
